import { type ReactNode } from 'react';

export type BadgeVariant = 'default' | 'terra' | 'sage' | 'plum' | 'danger' | 'outline';
type LegacyBadgeVariant = 'primary' | 'success' | 'warning' | 'info';

const LEGACY_ALIAS: Record<LegacyBadgeVariant, BadgeVariant> = {
  primary: 'terra',
  success: 'sage',
  warning: 'terra',
  info: 'default',
};

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant | LegacyBadgeVariant;
  dot?: boolean;
  className?: string;
}

export function Badge({ children, variant = 'default', dot = false, className = '' }: BadgeProps) {
  const resolved: BadgeVariant =
    variant in LEGACY_ALIAS ? LEGACY_ALIAS[variant as LegacyBadgeVariant] : (variant as BadgeVariant);
  return (
    <span className={`badge badge--${resolved} ${className}`.trim()}>
      {dot && <span className="badge__dot" />}
      {children}
    </span>
  );
}
